import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { runbookSystemActions } from "../../actions/runbookSystem.actions";

function RunbookSystemDropdown({ onChange, value, size, returnFullObject }) {
  const dispatch = useDispatch();
  const [runbookSystems, setRunbookSystems] = useState([]);
  const runbookSystemReducer = useSelector((state) => state.runbookSystem);

  useEffect(() => {
    dispatch(runbookSystemActions.getAll());

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setRunbookSystems(runbookSystemReducer.response);

    // eslint-disable-next-line
  }, [runbookSystemReducer.response]);

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    if (returnFullObject) {
      const systemObj = runbookSystems.find(rs => rs.system === selectedValue);
      onChange(systemObj);
    } else {
      onChange(selectedValue);
    }
  };

  return (
    <>
      {runbookSystems && (
        <Form.Select onChange={handleChange} value={value} size={size}>
          <option value={""}>-</option>
          {runbookSystems.map((rs, i) => (
            <option value={rs.system} key={i}>
              {rs.system}
            </option>
          ))}
        </Form.Select>
      )}
    </>
  );
}

export default RunbookSystemDropdown;
